import { useCallback, useMemo } from "react";
import moment from "moment";

import useUserRole from "src/app/Restricted/useUserRole";
import { useAllocationConfig } from "src/contexts/global/WorkspaceContext";
import { ADMIN_ROLE } from "src/services/auth";

export const useCheckPastAllocationEdits = () => {
  const userRole = useUserRole();
  const {
    enablePastAllocationEdits,
    pastAllocationEditsMaxDaysBack,
    pastAllocationEditsCutoffDate,
  } = useAllocationConfig();
  const isAdmin = userRole === ADMIN_ROLE;

  const isPastEditEnabled = enablePastAllocationEdits || isAdmin;

  const pastCutoffDate = useMemo(() => {
    // For admin, set cutoff date to null, allow edit any past date
    if (isAdmin) {
      return null;
    }

    // If past allocation edit is not enabled, set the cutoff date to Today
    // Start date can not be edited before today
    // End date can not be edited before yesterday
    if (!isPastEditEnabled) {
      return moment().startOf("day");
    }

    // if isPastEditEnabled is enabled
    // If max days back provided, use it as pastCutoffDate
    if (pastAllocationEditsMaxDaysBack) {
      return moment()
        .subtract(pastAllocationEditsMaxDaysBack, "days")
        .startOf("day");
    }

    // If cutoff date provided, use it as pastCutoffDate
    if (pastAllocationEditsCutoffDate) {
      return moment(pastAllocationEditsCutoffDate).startOf("day");
    }

    // if isPastEditEnabled is enabled, but no cutoff date set
    // allow edit any past date
    return null;
  }, [
    isAdmin,
    isPastEditEnabled,
    pastAllocationEditsMaxDaysBack,
    pastAllocationEditsCutoffDate,
  ]);

  const checkPastEditAllowed = useCallback(
    (date) => {
      if (date && pastCutoffDate) {
        return date.isSameOrAfter(pastCutoffDate);
      }

      return true;
    },
    [pastCutoffDate]
  );

  return {
    isAdmin,
    isPastEditEnabled,
    pastCutoffDate,
    checkPastEditAllowed,
  };
};
